import usePaymentLimitTableColumns from "../../hooks/usePaymentLimitTableColumns";
import useGeneralApi from "../../hooks/useGeneralApi";
import CreateUpdateForm from "./CreateUpdateForm";
import { TableFilter } from "@neonumy/ant-design";
import { FaCalendarDay } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CardTitle from "components/CardTitle";
import { Card } from "antd";

export default function PaymentDateLimit(): React.ReactElement {
  const urlParams: RouteParams = useParams();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const {
    listPaymentDeadlines,
    listPaymentDeadlinesTotalCount: totalCount,
    listPaymentDeadlinesData: dataSource,
    refetchListPaymentDeadlines: refetch,
    loadingListPaymentDeadlines: loading,
  } = useGeneralApi();

  useEffect(() => {
    listPaymentDeadlines({
      variables: {
        limit: pageSize,
        offset: 0,
        orderBy: ["name"],
        filter: {
          company: urlParams.companyId,
        },
      },
    });
  }, []);
  const columns = usePaymentLimitTableColumns(refetch);

  const handlePagination = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(page);
    refetch({
      limit: size,
      offset: size * (page - 1),
    });
  };

  return (
    <>
      <Card
        title={<CardTitle icon={<FaCalendarDay />} title={t("Payment Date Limit")} />}
        className="antd-newrai-card"
      >
        <TableFilter
          className="antd-newrai-table"
          size="small"
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={{
            onChange: handlePagination,
            showSizeChanger: true,
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showTotal: total => t("Total table items", { count: total }),
          }}
        />
        <CreateUpdateForm refetch={refetch} />
      </Card>
    </>
  );
}
